// extracted by mini-css-extract-plugin
export default {"ldsRoller":"Spinner_ldsRoller__+sNQQ"};